import React from 'react';

import { observer } from 'mobx-react';

export const StatisticsDashboard = observer(function StatisticsDashboard() {
  return <div style={{ textAlign: 'center' }}>Kommer snart</div>;
});
